module.exports = __webpack_public_path__ + "static/media/photo253.dfe2e3f8.jpg";